export default "__VITE_ASSET__BNrcdpUf__"